import DOMPurify from 'dompurify';
import { escapeRegExp } from 'lodash';

interface ISusyHighlighterProps {
    searchTerm: string;
    textToHighlight: string;
}

const SusyHighlighter = ({
    searchTerm,
    textToHighlight,
}: ISusyHighlighterProps) => {
    if (!searchTerm || !textToHighlight) {
        return <span>{textToHighlight}</span>;
    }

    const searchTermWithEscapedSpecialCharacters = escapeRegExp(searchTerm);

    const regexp = new RegExp(searchTermWithEscapedSpecialCharacters, 'gi');
    const textWithReplacedSearchTerm = textToHighlight.replaceAll(
        regexp,
        `<mark class='highlighted-text'>${searchTerm}</mark>`
    );

    return (
        <span
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textWithReplacedSearchTerm),
            }}
        ></span>
    );
};

export default SusyHighlighter;
